import api from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ClipboardCheck, ClipboardList, Users } from "lucide-react";

const getListDataPendaftaran = async (
  page: string,
  rowsPerPage: string,
  searchQuery?: string,
  idsUkParams?: string,
  tanngalWawancaraParams?: string,
  sesiParams?: string,
  statusParams?: string,
) => {
  const response = await api.get(
    `/verifikator/peserta-wawancara-talent/index?page=${page}${
      rowsPerPage ? `&rowsPerPage=${rowsPerPage}` : ""
    }${searchQuery ? `&searchQuery=${searchQuery}` : ""}${
      idsUkParams ? `&ids_uk=${idsUkParams}` : ""
    }${
      tanngalWawancaraParams
        ? `&tanggal_wawancara=${tanngalWawancaraParams}`
        : ""
    }${sesiParams ? `&sesi=${sesiParams}` : ""}${
      statusParams ? `&status_nilai=${statusParams}` : ""
    }`,
    {
      withCredentials: true,
    },
  );
  return response.data?.data;
};

export default function DataPendaftaranPesertaTalentscoutingPage() {
  const [searchParams] = useSearchParams();

  const pageParams = searchParams.get("page") || "1";
  const rowsPerPageParams = searchParams.get("rowsPerPage");
  const searchQueryParams = searchParams.get("search");
  const idsUkParams = searchParams.get("ids_uk");
  const tanngalWawancaraParams = searchParams.get("tanggal_wawancara");
  const sesiParams = searchParams.get("sesi");
  const statusParams = searchParams.get("status");

  const { data, isPending } = useQuery({
    queryKey: [
      "listDataPendaftaran",
      pageParams,
      rowsPerPageParams,
      searchQueryParams,
      idsUkParams,
      tanngalWawancaraParams,
      sesiParams,
      statusParams,
    ],
    queryFn: () =>
      getListDataPendaftaran(
        pageParams as string,
        rowsPerPageParams as string,
        searchQueryParams as string,
        idsUkParams as string,
        tanngalWawancaraParams as string,
        sesiParams as string,
        statusParams as string,
      ),
  });

  const { data: dataAnalitik, isPending: isPendingAnalitik } = useQuery({
    queryKey: [
      "listDataPendaftaranAnalitik",
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
    ],
    queryFn: () =>
      getListDataPendaftaran(
        "1",
        "9999",
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
      ),
  });

  const sudahDinilai =
    dataAnalitik?.data?.filter((item: any) => item.jml_komponen_dinilai == 10)
      ?.length || 0;
  const belumDinilai =
    dataAnalitik?.data?.filter((item: any) => item.jml_komponen_dinilai != 10)
      ?.length || 0;
  const totalPeserta = dataAnalitik?.data?.length || 0;

  return (
    <div className="space-y-4">
      <div className="grid gap-4 md:grid-cols-3">
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Total Peserta</CardTitle>
            <Users className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">
              {isPendingAnalitik ? "..." : totalPeserta}
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Sudah Dinilai</CardTitle>
            <ClipboardCheck className="h-4 w-4 text-emerald-500" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">
              {isPendingAnalitik ? "..." : sudahDinilai}
            </div>
            <p className="text-xs text-muted-foreground">
              Peserta dengan 10 komponen nilai
            </p>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Belum Dinilai</CardTitle>
            <ClipboardList className="h-4 w-4 text-rose-500" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">
              {isPendingAnalitik ? "..." : belumDinilai}
            </div>
            <p className="text-xs text-muted-foreground">
              Peserta kurang dari 10 komponen nilai
            </p>
          </CardContent>
        </Card>
      </div>

      <div>
        <DataTable
          data={data?.data || []}
          paginationData={data}
          columns={columns}
          isPending={isPending}
        />
      </div>
    </div>
  );
}
